import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import './styles/index.css';

// Deep links depend on the SPA catch-all rewrite in client/vercel.json.
// BrowserRouter resolves routes in the browser, so a hard refresh or a pasted
// link on any path but / reaches Vercel as a real request. Without that rewrite
// it 404s before React ever mounts. The two are a pair, and because `vite dev`
// serves index.html for everything, breaking one only shows up in production.
ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
